const useDataLayer = dataLayerProps => ({
  push: item => {
    const dataLayerItem = { ...item, ...dataLayerProps }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(dataLayerItem)
  }
})

export default useDataLayer
